import { render, staticRenderFns } from "./EmployeeHorary.vue?vue&type=template&id=2fb9fc46&scoped=true&"
import script from "./EmployeeHorary.vue?vue&type=script&lang=js&"
export * from "./EmployeeHorary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb9fc46",
  null
  
)

export default component.exports